// src/pages/CalculoHonorarios/components/DadosTrabalho.js

import React from 'react';

const DadosTrabalho = ({ formData, onChange }) => {
  const renderCampoComDescricao = (label, icone, nomeCampo, nomeDescricao, opcoes, placeholder) => (
    <div className="form-group-complexo">
      <label className="field-label">
        <span>{icone}</span>
        {label}
      </label>
      <div className="form-row">
        <select
          value={formData[nomeCampo] || ''}
          onChange={(e) => onChange(nomeCampo, e.target.value)}
          className="form-input select-nivel"
        >
          <option value="">Selecionar...</option>
          {opcoes.map(opcao => (
            <option key={opcao} value={opcao}>{opcao}</option>
          ))}
        </select>
      </div>
      <textarea
        value={formData[nomeDescricao] || ''}
        onChange={(e) => onChange(nomeDescricao, e.target.value)}
        placeholder={placeholder}
        className="form-textarea"
        rows="3"
      />
    </div>
  );

  return (
    <div className="formulario-secao">
      <h3>⚖️ Parte 2 — Dados do Trabalho</h3>

      {renderCampoComDescricao(
        'Complexidade',
        '🧩',
        'complexidade',
        'complexidade_descricao',
        ['Alta', 'Normal', 'Baixa'],
        'Exemplos:\n- Grau de dificuldade jurídica\n- Novidade das questões\n- Volume documental\n- Necessidade de investigação/articulação com outras áreas'
      )}

      {renderCampoComDescricao(
        'Importância (econômica e reputacional)',
        '💼',
        'risco',
        'risco_descricao',
        ['Alta', 'Normal', 'Baixa'],
        'Exemplos:\n- Valor econômico do litígio\n- Relevância pessoal, familiar, patrimonial ou reputacional\n- Impacto de decisões e consequências jurídicas'
      )}

      {renderCampoComDescricao(
        'Urgência do Trabalho',
        '⏰',
        'urgencia',
        'urgencia_descricao',
        ['Alta', 'Normal', 'Baixa'],
        'Exemplos:\n- Prazos curtos\n- Trabalho fora do horário\n- Necessidade de reorganizar agenda'
      )}
    </div>
  );
};

export default DadosTrabalho;